import nanoajax from 'nanoajax';
import { mapState, mapActions } from 'vuex';
import { serializeToQs, decode } from 'utils/general';

import validate from 'mixins/validate';
import phone from 'mixins/phone-validation';
import signups from 'mixins/signups';
import formGlobalErrors from 'mixins/form-global-errors';
import 'lib/vue-phone-input.js';
import { pushDataFinderSaved } from 'lib/tracking';

const ATTENTIVE_CREATIVE_ID = '66764';

export default {
  components: {
    'product-hero': () => import('../product-hero/product-hero.vue'),
  },
  mixins: [validate, phone, signups, formGlobalErrors],
  props: [
    'customerEmail',
    'customerKey',
    'savedMsg',
    'shade',
    'formId',
    'klaviyoListId',
    'baseUrl',
    'months',
  ],
  data() {
    return {
      config: {
        email: false,
        step: 'start',
        failedLogin: 'Incorrect email or password',
        failedRecover: 'No account found with that email.',
        failedMany: 'Too Many Requests',
        failedMsg: '',
        loginErr: false,
        recoverErr: false,
        disabledSend: false,
      },
      firstNameValue: '',
      lastNameValue: '',
      emailValue: '',
      passwordValue: '',
      acceptMarketing: false,
      countryValue: '',
      birthdayRequired: false,
      birthday: [],
      savedStatus: false,
      statusBack: false,
    };
  },
  computed: {
    ...mapState('global'),
    ...mapState('shadeFinder', ['loggedIn', 'customerId']),
    actionsDisabled() {
      return this.config.disabledSend;
    },
    showBack() {
      return this.statusBack;
    },
  },
  mounted() {
    if (this.customerEmail || this.loggedIn) {
      this.config.step = 'saved';
      this.saveShadeNumber();
    }
  },
  methods: {
    ...mapActions('global', ['closeModal']),
    prevSaveStep() {
      this.config.step = 'start';
      this.statusBack = false;
    },
    goToForm(status) {
      this.config.step = status;

      if (
        status === 'login' ||
        status === 'forgot' ||
        status === 'create' ||
        status === 'send'
      ) {
        this.statusBack = true;
      } else {
        this.statusBack = false;
      }
    },
    inputEmailAddress() {
      const formData = this.formData();
      const email = formData.email?.toString() || false;
      this.config['email'] = email;
    },
    loginCustomer() {
      const formData = this.formData();
      const email = formData.email?.toString() || false;
      const password = formData.password?.toString() || false;

      if (password && email) {
        this.login(email, password);
      }
    },
    recoverPassword() {
      const formData = this.formData();
      const email = formData.email?.toString() || false;

      if (email) {
        this.recover(email);
      }
    },
    resetEmail() {
      this.config.disabledSend = true;
      this.config.step = 'start';
      this.statusBack = false;
    },
    login(email, password, retry = false) {
      const self = this;
      const payload = {
        'customer[email]': email,
        'customer[password]': password,
        form_type: 'customer_login',
        utf8: '✓',
      };

      nanoajax.ajax(
        {
          url: '/account/login',
          method: 'POST',
          body: serializeToQs(payload),
        },
        (code, responseText, request) => {
          if (code === 429) {
            self.config.recoverErr = true;
            self.config.failedMsg = self.config.failedMany;
          } else if (responseText.indexOf(self.config.failedLogin) !== -1) {
            self.config.loginErr = true;
            self.config.failedMsg = self.config.failedLogin;
          } else {
            const customerId = responseText
              .split('{"page":{"customerId":')[1]
              .split('}')[0];
            self.config.loginErr = false;
            this.$store.commit('shadeFinder/setState', {
              key: 'loggedIn',
              value: true,
            });
            this.$store.commit('shadeFinder/setState', {
              key: 'customerId',
              value: customerId,
            });
            self.saveShadeNumber();

            const parser = new DOMParser();
            const responseDoc = parser.parseFromString(
              responseText,
              'text/html',
            );
            const previousDesktopAccountIcon = document.querySelector(
              '[data-header-account-desktop]',
            );
            const previousMobileAccountIcon = document.querySelector(
              '[data-header-account-mobile]',
            );
            const updatedDesktopIcon = responseDoc.querySelector(
              '[data-header-account-desktop]',
            );
            const updatedMobileIcon = responseDoc.querySelector(
              '[data-header-account-mobile]',
            );

            previousDesktopAccountIcon.replaceWith(updatedDesktopIcon);
            previousMobileAccountIcon.replaceWith(updatedMobileIcon);
          }
        },
      );
    },
    recover(email) {
      const self = this;
      const payload = {
        email,
        form_type: 'recover_customer_password',
        utf8: '✓',
      };

      nanoajax.ajax(
        {
          url: '/account/recover',
          method: 'POST',
          body: serializeToQs(payload),
        },
        (code, responseText, request) => {
          if (code === 429) {
            self.config.recoverErr = true;
            self.config.failedMsg = self.config.failedMany;
          } else if (
            responseText.indexOf(self.config.failedMsgRecover) !== -1
          ) {
            self.config.recoverErr = true;
            self.config.failedMsg = self.config.failedRecover;
          } else {
            self.config.recoverErr = false;
            self.goToForm('login');
          }
        },
      );
    },
    saveShadeNumber() {
      const self = this;
      this.config.step = 'saved';
      let userId = this.customerId;
      if (this.customerKey) {
        userId = this.customerKey;
      }
      fetch(
        `https://app.accentuate.io/proxy/customer/${__GLOBAL__.shopHandle}.myshopify.com`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'customer[id]': userId,
            'metafield[shade.shade_number]': self.shade,
          }),
          redirect: 'follow',
        },
      )
        .then((response) => response.text())
        .then((result) => {
          self.savedStatus = true;
          pushDataFinderSaved();
          return true;
        })
        .catch((error) => console.log('error', error));
    },
    onAcceptChange(obj) {
      if (obj.value) {
        this.acceptMarketing = true;
      } else {
        this.acceptMarketing = false;
      }
    },
    sendToEmail(firstSend) {
      const formData = this.formData();
      const email =
        formData.email?.toString() || this.customerEmail || this.config.email;
      if (email) {
        window.klaviyo.push([
          'identify',
          {
            $email: email,
          },
        ]);
        window.klaviyo.push([
          'track',
          'Fenty Face - Shade Number',
          __GLOBAL__.shade_email,
        ]);

        pushDataFinderSaved();

        if (this.acceptMarketing) {
          let sanitizeBirthday = '';
          this.emailValue = email;

          if (this.birthday.every((val) => val !== 'placeholder')) {
            sanitizeBirthday = this.birthday.join('/');
          }
          this.submitToKlaviyo({
            listId: this.klaviyoListId,
            email: this.emailValue,
            $first_name: this.firstNameValue,
            $last_name: this.lastNameValue,
            acceptMarketing: this.acceptMarketing,
            birthday: sanitizeBirthday,
          });
        }

        if (firstSend) {
          this.config.step = 'sent';
          this.config.email = email;
        } else {
          this.$refs['fb-resend-accept'].isChecked = false;
        }
      }
    },
    submitButtonState() {
      const showErrors = false;
      const isButtonActive = this.validateCustomForm(showErrors);
      const btn = this.$refs['ref-shade-create-account'];

      isButtonActive
        ? btn.classList.remove('is-disabled')
        : btn.classList.add('is-disabled');
    },
    phoneOnChange() {
      this.phoneValidation(true);
      this.submitButtonState();
    },
    generateCountryArray() {
      return Object.keys(Countries).map((label) => ({
        label,
        value: label,
      }));
    },
    validateCustomForm(showErrors = true) {
      const checkPhone = this.phoneValidation();
      const countrySelectDropdown = this.$refs['countrySelect'];
      const daysDropdown = this.$refs['daysDropdown'];
      const monthsDropdown = this.$refs['monthsDropdown'];

      let isValid = this.$children
        .filter((c) => typeof c.validateInput !== 'undefined')
        .map((c) => {
          const validInput = c.validateInput();
          if (showErrors) {
            this.highlightErrors(c, validInput);
          }

          return c.validateInput();
        })
        .every((res) => res);

      // check if country region select is not empty
      if (countrySelectDropdown.inputValue === 'placeholder') {
        if (showErrors) {
          countrySelectDropdown.isValid = false;
        }
        isValid = false;
      }

      // check if birthday is required
      if (this.birthdayRequired) {
        if (daysDropdown.inputValue === 'placeholder') {
          if (showErrors) {
            daysDropdown.isValid = false;
          }

          isValid = false;
        }

        if (monthsDropdown.inputValue === 'placeholder') {
          if (showErrors) {
            monthsDropdown.isValid = false;
          }
          isValid = false;
        }
      }

      // check if user added a phone and if its valid
      if (!checkPhone) {
        isValid = false;

        if (showErrors) {
          this.phoneValidation(true);
        }
      }

      return isValid;
    },
    saveCustomer() {
      const isValidForm = this.validateCustomForm();
      const countryVal =
        this.countryValue === 'placeholder' ? '' : this.countryValue;
      const customerSaveOptions = {
        login: false,
        redirect: false,
        formId: this.formId,
        data: {
          first_name: this.firstNameValue,
          last_name: this.lastNameValue,
          email: this.emailValue,
          password: this.passwordValue,
          password_confirmation: this.passwordValue,
          accepts_marketing: this.acceptMarketing,
          birthday_day_int:
            this.birthday[1] === 'placeholder' ? '' : this.birthday[1],
          birthday_month:
            this.birthday[0] === 'placeholder' ? '' : this.birthday[0],
          default_address: {
            country: countryVal,
          },
          phone: this.phoneValue,
        },
      };

      if (isValidForm) {
        this.showLoader('show');
        let sanitizeBirthday = '';
        if (this.birthday.every((val) => val !== 'placeholder')) {
          sanitizeBirthday = this.birthday.join('/');
        }
        this.submitToKlaviyo({
          listId: this.klaviyoListId,
          email: this.emailValue,
          $first_name: this.firstNameValue,
          $last_name: this.lastNameValue,
          acceptMarketing: this.acceptMarketing,
          birthday: sanitizeBirthday,
        })
          .then(() => {
            this.submitToAttentive(ATTENTIVE_CREATIVE_ID);
          })
          .then(() => {
            this.submitToCF(customerSaveOptions);
          });
      }
    },
    onInputChange({ name, value }) {
      const match = /\[(\w*)\]/.exec(name);
      const countrySelectDropdown = this.$refs['countrySelect'];
      const daysDropdown = this.$refs['daysDropdown'];
      const monthsDropdown = this.$refs['monthsDropdown'];

      if (!match || !match[1]) {
        return false;
      }

      if (
        (match[1] === 'Day' || match[1] === 'Month') &&
        value !== 'placeholder'
      ) {
        this.birthdayRequired = true;
      }

      switch (match[1]) {
        case 'first_name':
          this.firstNameValue = value;
          break;
        case 'last_name':
          this.lastNameValue = value;
          break;
        case 'email':
          this.emailValue = value;
          break;
        case 'password':
          this.passwordValue = value;
          break;
        case 'sms':
          this.phoneSendSMS = !!value;
          break;
        case 'accepts_marketing':
          this.acceptMarketing = !!value;
          break;
        case 'country':
          countrySelectDropdown.isValid = true;
          this.countryValue = value;
          break;
        case 'Month':
          monthsDropdown.isValid = true;
          this.birthday[0] = value;
          break;
        case 'Day':
          daysDropdown.isValid = true;
          this.birthday[1] = value;
          break;
        default:
          break;
      }

      this.phoneValidation(true);
      this.submitButtonState();
    },
    submitToCF(customerSaveOptions) {
      // Clear global errors
      this.globalErrors = '';
      const self = this;

      CF.domain = 'fentybeautyshop.myshopify.com';
      CF.customer.shopDomain = 'fentybeautyshop.myshopify.com';

      CF.customer
        .save(customerSaveOptions)
        .then((response) => {
          // updates first name, last name, email and phone
          if (response) {
            self.displayResponseErrors(response);
            self.showLoader('hide');
          } else {
            self.login(self.emailValue, self.passwordValue, true);
          }
        })
        .catch(function (err) {
          console.error('Could not save customer', err);
          self.showLoader('hide');
        });
    },
    showLoader(show = 'show') {
      const element = this.$el.querySelector('.register-form');
      if (show === 'show') {
        element.classList.add('is-loading');
      } else {
        element.classList.remove('is-loading');
      }
    },
    generateMonths() {
      const arr = JSON.parse(decode(this.months));

      return Object.keys(arr).map((label) => ({
        label,
        value: label,
      }));
    },
    generateDays() {
      const arr = [];
      const maxDays = 31;

      for (let index = 1; index <= maxDays; index++) {
        const obj = {
          label: index,
          value: index,
        };

        arr.push(obj);
      }

      return arr;
    },
  },
};
